(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'QZWtTQ';
  var BIS_ENDPOINT =
    'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;

  var modal = null;
  var currentVariantId = null;

  function createModal() {
    modal = document.createElement('div');
    modal.className = 'notify-me-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Notify me when available');
    modal.innerHTML =
      '<div class="notify-me-modal__backdrop"></div>' +
      '<div class="notify-me-modal__panel">' +
        '<button type="button" class="notify-me-modal__close" aria-label="Close">&times;</button>' +
        '<div class="notify-me-modal__step notify-me-modal__step--form is-active">' +
          '<h3 class="notify-me-modal__title"></h3>' +
          '<p class="notify-me-modal__desc">Enter your email and we\'ll notify you when this item is back in stock.</p>' +
          '<form class="notify-me-modal__form" novalidate>' +
            '<label for="notify-me-email" class="notify-me-modal__label">Email</label>' +
            '<input type="email" id="notify-me-email" class="notify-me-modal__input" placeholder="your@email.com" required autocomplete="email">' +
            '<div class="notify-me-modal__error" role="alert" aria-live="polite"></div>' +
            '<button type="submit" class="notify-me-modal__submit button">Notify Me When Available</button>' +
          '</form>' +
        '</div>' +
        '<div class="notify-me-modal__step notify-me-modal__step--success">' +
          '<h3 class="notify-me-modal__title">You\'re in!</h3>' +
          '<p class="notify-me-modal__desc">We\'ll let you know when it\'s back in stock.</p>' +
          '<button type="button" class="notify-me-modal__done button">Continue Shopping</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);

    modal.querySelector('.notify-me-modal__backdrop').addEventListener('click', closeModal);
    modal.querySelector('.notify-me-modal__close').addEventListener('click', closeModal);
    modal.querySelector('.notify-me-modal__done').addEventListener('click', closeModal);
    modal.querySelector('.notify-me-modal__form').addEventListener('submit', handleSubmit);
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal(variantId, productTitle) {
    if (!modal) createModal();
    currentVariantId = variantId;

    modal.querySelectorAll('.notify-me-modal__step').forEach(function (s) {
      s.classList.remove('is-active');
    });
    modal.querySelector('.notify-me-modal__step--form').classList.add('is-active');

    modal.querySelector('.notify-me-modal__step--form .notify-me-modal__title').textContent =
      productTitle;

    var emailInput = modal.querySelector('#notify-me-email');
    emailInput.value = '';
    modal.querySelector('.notify-me-modal__error').textContent = '';

    var submitBtn = modal.querySelector('.notify-me-modal__submit');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Notify Me When Available';

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    emailInput.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function handleSubmit(e) {
    e.preventDefault();
    var emailInput = modal.querySelector('#notify-me-email');
    var email = emailInput.value.trim();
    var errorEl = modal.querySelector('.notify-me-modal__error');
    var submitBtn = modal.querySelector('.notify-me-modal__submit');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      return;
    }

    errorEl.textContent = '';
    submitBtn.disabled = true;
    submitBtn.textContent = 'Subscribing...';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + currentVariantId
            }
          }
        }
      }
    };

    fetch(BIS_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.status === 202 || res.ok) {
          modal.querySelector('.notify-me-modal__step--form').classList.remove('is-active');
          modal.querySelector('.notify-me-modal__step--success').classList.add('is-active');
        } else {
          throw new Error('Status ' + res.status);
        }
      })
      .catch(function () {
        errorEl.textContent = 'Something went wrong. Please try again.';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify Me When Available';
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.notify-me-trigger');
    if (!trigger) return;
    e.preventDefault();
    openModal(trigger.dataset.variantId, trigger.dataset.productTitle || 'This item');
  });
})();
